// Values are the core-service /api/desktop_commands command names
export const SUPPORT_ACTIONS = {
  FORCE_LOGOUT: 'force_logout',
  PULL_LOGS: 'export_logs',
  START_CALL: 'start_call',
  STOP_CALL: 'stop_call',
  FORCE_RELOAD: 'force_reload',
  FORCE_RELOAD_DURING_CALL: 'force_reload_in_call',
}

export const SUPPORT_ACTION_OPTIONS = [
  {
    value: SUPPORT_ACTIONS.FORCE_LOGOUT,
    label: 'Force Logout',
    description: 'Ends any active call and logs them out of the desktop app',
  },
  {
    value: SUPPORT_ACTIONS.PULL_LOGS,
    label: 'Pull Logs',
    description: 'Emails their desktop app logs to you',
  },
  {
    value: SUPPORT_ACTIONS.START_CALL,
    label: 'Start Call',
    description: 'Starts a call in their desktop app',
  },
  {
    value: SUPPORT_ACTIONS.STOP_CALL,
    label: 'Stop Call',
    description: 'Ends their active call',
  },
  {
    value: SUPPORT_ACTIONS.FORCE_RELOAD,
    label: 'Force Reload',
    description: 'Reloads their desktop app once their current call ends',
  },
  {
    value: SUPPORT_ACTIONS.FORCE_RELOAD_DURING_CALL,
    label: 'Force Reload During Call',
    description: 'Reloads their desktop app right away, even in the middle of a call',
  },
]

// Pulling logs and starting a call can't cut off a call in progress; every other action can
export const NON_DISRUPTIVE_SUPPORT_ACTIONS = [
  SUPPORT_ACTIONS.PULL_LOGS,
  SUPPORT_ACTIONS.START_CALL,
]

export const SUPPORT_ACTION_DELIVERED = 'delivered'

// Past this, the toast for users a support action didn't reach just gives a count
export const MAX_LISTED_UNREACHED_USERS = 5
